import React, { useEffect, useState } from 'react';
import axios, { AxiosError } from 'axios';
import { FaChevronLeft } from 'react-icons/fa';
import { useToasts } from 'react-toast-notifications';
import { Container, Loader, Modal, Typography } from 'amphitheatre';

import { ReturnButton } from './Upload.styled';
import { UploadLi } from './Upload.components';

const { Header, Paragraph } = Typography;

interface Props {
  goBack: () => void;
}

function getExtension(filename: string) {
  return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);
}

const UploadList: React.FunctionComponent<Props> = ({ goBack }: Props) => {
  const [files, setFiles] = useState<string[] | undefined>([]);
  const [deletes, setDeletes] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [fileToDelete, setFileToDelete] = useState('');
  const { addToast } = useToasts();

  useEffect(() => {
    let isMounted = true;

    axios
      .get('/api/bluequest/submit')
      .then((res) => {
        if (res && res.data) {
          if (isMounted) setFiles(res.data.files);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status !== 401) {
          addToast(error.message, { appearance: 'error', autoDismiss: true });
        }
        setFiles(undefined);
      });
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deletes]);

  function deleteFile(file: string) {
    setFileToDelete(file);
    setShowModal(true);
  }

  function confirmDeletion() {
    setFiles([]);
    setShowModal(false);
    axios
      .delete(`/api/bluequest/delete/${fileToDelete}`)
      .then(() => {
        setDeletes(deletes + 1);
      })
      .catch((error) => {
        addToast(error.message, { appearance: 'error', autoDismiss: true });
      });
  }

  return (
    <Container className="content-container" size="lg">
      <Modal
        cancel={() => setShowModal(false)}
        confirm={confirmDeletion}
        style={{ maxWidth: '600px', minWidth: '600px' }}
        visible={showModal}
      >
        <Paragraph>
          Are you sure you want to delete the file, <b>{fileToDelete}</b>?
        </Paragraph>
      </Modal>
      <ReturnButton onClick={goBack}>
        <div className="icon">
          <FaChevronLeft />
        </div>
        Back
      </ReturnButton>
      <Header>Files you have uploaded</Header>
      {files ? (
        files.length ? (
          files.map((file) => {
            return (
              <UploadLi
                key={file}
                type={getExtension(file)}
                onClick={() => deleteFile(file)}
              >
                {file}
              </UploadLi>
            );
          })
        ) : (
          <div style={{ textAlign: 'center' }}>
            <Loader message="Loading files ..." />
          </div>
        )
      ) : (
        'You have no files'
      )}
    </Container>
  );
};

export default UploadList;
